import config from "config/config";

export async function getFormsByCategories(
  portal,
  portalSubCategory = 0,
  state = ""
) {
  let options = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ClientSecret: config.PORTAL_CLIENT_SECRET,
    },
  };
  let url =
    config.REG_API_BASE_URL +
    "/Form?portalCategoryNumber=0" +
    "&portalSubCategoryNumber=" +
    portalSubCategory +
    "&portal=" +
    portal;
  const filterState = "&State=" + state;
  const response = await fetch(
    `${url}${state && state !== "" ? filterState : ""}`,
    options
  );
  if (!response.ok) {
    throw response;
  } else {
    const data = await response.json();
    return data;
  }
}

export async function getFormDocument(templateId, companyName) {
  let options = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ClientSecret: config.PORTAL_CLIENT_SECRET,
    },
  };
  let url =
    config.REG_API_BASE_URL +
    "/Form/document?TemplateId=" +
    encodeURIComponent(templateId) +
    "&BlockCode=" +
    companyName;
  const response = await fetch(url, options);
  if (!response.ok) {
    throw response;
  } else {
    const data = await response.json();
    return data;
  }
}
